export default {
  set(state, { data }) {
    state.sales = data;
  },
  show(state, { data }) {
    state.sale = data;
  },
  getPage(state, { data }) {
    state.page = data
  },
  setB(state, { data }) {
    state.salesB = data;
  },
  getPageB(state, { data }) {
    state.pageB = data
  },
}